(function () {
  'use strict';

  angular.module('app.admin')
    .factory('adminStatusService', ['$q', '$http', '$rootScope',
      function ($q, $http, $rootScope) {

        var service = {};

        function checkResponse(data) {
          return data;
        }

        function getMessage(data) {
          if (data) {
            return data.message;
          }
          return false;
        }

        function handleRequest(url) {
          var deferred = $q.defer(), result = 'requestFail';
          $http.get(url)
            .success(function (data) {
              var dataRes = angular.fromJson(data);

              if (checkResponse(dataRes)) {
                deferred.resolve(dataRes);
              } else {
                deferred.reject(getMessage(dataRes) || result);
              }
            })
            .error(function () {
              deferred.reject(result);
            });

          return deferred.promise;
        }

        // function getStatusData() {
        //   var url = $rootScope.apiUrl + 'admin/getStatusData';
        //   // var url = 'app/admin/status/data.json';
        //   return handleRequest(url);
        // }

        function getStatusOverview() {
          var url = $rootScope.apiUrl + 'admin/getStatusOverview';
          return handleRequest(url);
        }

        function getStatusNewInfluencers() {
          var url = $rootScope.apiUrl + 'admin/getStatusNewInfluencers';
          return handleRequest(url);
        }

        function getStatusPlatforms() {
          var url = $rootScope.apiUrl + 'admin/getStatusPlatforms';
          return handleRequest(url);
        }

        function getStatusCountries() {
          var url = $rootScope.apiUrl + 'admin/getStatusCountries';
          return handleRequest(url);
        }

        // service.getStatusData = getStatusData;
        service.getStatusOverview = getStatusOverview;
        service.getStatusNewInfluencers = getStatusNewInfluencers;
        service.getStatusPlatforms = getStatusPlatforms;
        service.getStatusCountries = getStatusCountries;

        return service;
      }]);

  

})();
